import { Injectable } from '@angular/core';
import { Adapter } from 'src/utils/interfaces/adapter-service.interfaces';
import { RotorTypeFormsData } from 'src/utils/interfaces/rotor-type-forms-data.interfaces';
import { CheckboxStatus } from '@schenck/rotec-components';
import { CalibrationAndCompensationParameters } from 'src/utils/interfaces/rotor-type.interfaces';

@Injectable({
  providedIn: 'root',
})
export class CalibrationsAndCompensationsAdapter
  implements Adapter<RotorTypeFormsData, CalibrationAndCompensationParameters>
{
  /**
   * Creates the adapted form data for Calibrations and Compensations step
   *
   * @param formData: RotorTypeFormsData
   * @returns CalibrationAndCompensationParameters
   */
  adapt({
    calibrationsAndCompensationsStep,
  }: RotorTypeFormsData): CalibrationAndCompensationParameters {
    return {
      typeSpecificKeyCompensationParameter: {
        enableCalibration: {
          value: this.convertFormValuesToNumber(
            calibrationsAndCompensationsStep.keyCompensationToggle,
            calibrationsAndCompensationsStep.keyCompensationCheckbox
          ),
          isEdited: true,
        },
      },
      typeSpecificBiasCompensationParameter: {
        enableCalibration: {
          value: this.convertFormValuesToNumber(
            calibrationsAndCompensationsStep.biasCompensationToggle,
            calibrationsAndCompensationsStep.biasCompensationCheckbox
          ),
          isEdited: true,
        },
      },
      typeSpecificIndexCompensationParameter: {
        enableCalibration: {
          value: this.convertFormValuesToNumber(
            calibrationsAndCompensationsStep.indexCompensationToggle,
            calibrationsAndCompensationsStep.indexCompensationCheckbox
          ),
          isEdited: true,
        },
      },
      typeSpecificUnbalanceCalibrationParameter: {
        enableCalibration: {
          value: this.convertFormValuesToNumber(
            calibrationsAndCompensationsStep.unbalanceCalibrationToggle,
            calibrationsAndCompensationsStep.unbalanceCalibrationCheckbox
          ),
          isEdited: true,
        },
      },
    };
  }

  convertFormValuesToNumber(toggle: boolean, checkboxValue: CheckboxStatus): number {
    if (!toggle) {
      return 0;
    } else if (toggle) {
      return checkboxValue === 'checked' ? 2 : 1;
    }
  }
}
